import { PlayerUserDetailSkeleton } from "components/Skeleton/PlayerUsersPage/PlayerUserDetailSkeleton";
import { setScrollBehavior } from "features/scrollPageBehaviorProvider/scrollPageBehaviorProvider";
import client from "libs/client";
import { useEffect } from "react";
import { useParams } from "react-router";
import SkeletonBox from "ui-kit/src/Skeleton/SkeletonBox";
import NotFoundPage from "./errorPages/NotFoundPage";
import { DiscoverGameResponse } from "libs/apiClient";
import {DiscoverBreadcrumbs} from "features/discover/DiscoverBreadcrumbs";
import {DiscoverGameDetail} from "features/discover/DiscoverGameDetail";

export function DiscoverGamePage() {
    const { id } = useParams();

    useEffect(() => { setScrollBehavior() }, [])

    const { data: response, isLoading, error } = client.getDiscoverGame.useQuery({ id: parseInt(id || "") }, { queryKey: ["discoverGameDetail"] })

    if (error) {
        const code = error?.response.status;

        if (code === 404) {
            return (
                <div>
                    <NotFoundPage />
                </div>
            );
        }
    }

	const data: DiscoverGameResponse = response?.data || {} as DiscoverGameResponse

	return (
        <div className="discover-container">
            <div className="pageHeading">
				{isLoading
					? <SkeletonBox style={{ width: "300px", height: "32px", margin: "35px 0 35px 0" }} />
					: <DiscoverBreadcrumbs items={[
						{
							label: 'Games',
							route: '/discover/game'
						},
						{
							label: `${data.id}`,
							note: data.id,
						},
					]} />
				}

			</div>
			{isLoading
				? <PlayerUserDetailSkeleton/>
				: <DiscoverGameDetail gameData={data} />}
        </div>
    )
}
